import { StandardEvents } from '@shopify/events';
// Consume the existing theme request. No extra network request or gallery is created.
class FCVariantFacts extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.version = 0;
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.onSelect, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.version++; this.controller?.abort(); }
  onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
    const version = ++this.version;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || this.version !== version || !detail?.html) return;
      const next = [...detail.html.querySelectorAll('fc-variant-facts')].find(el => el.dataset.productId === this.dataset.productId && el.dataset.factsKind === this.dataset.factsKind);
      if (next) this.replaceWith(next);
    }).catch(error => { if (error?.name !== 'AbortError') console.warn('[fc-variant-facts] Variant facts update failed:', error); });
  };
}
if (!customElements.get('fc-variant-facts')) customElements.define('fc-variant-facts', FCVariantFacts);

